import { render, staticRenderFns } from "./FornecedorIndustriaSidebarImportacao.vue?vue&type=template&id=32906a9d&"
import script from "./FornecedorIndustriaSidebarImportacao.vue?vue&type=script&lang=js&"
export * from "./FornecedorIndustriaSidebarImportacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
